import i18next from '../../i18n';
import type { StartImportJobApiArgs } from '../../@types/background-jobs';
import type { ValidationResponseMessage } from '../../@types/common';
import { fileApi } from '../../redux/services/file';
import { appDispatch } from '../../redux/store-accessors';
import { showError, showSuccess } from '../notification.service';
import { BackgroundJobHandler } from './background-job.handler';
import { recordApi } from '../../redux/services/record';

export class ImportAttachmentsHandler extends BackgroundJobHandler<StartImportJobApiArgs> {
  constructor(apiProps: StartImportJobApiArgs, details: Record<string, unknown>) {
    super(apiProps, details);
  }

  public async createBackgroundJob(apiProps: StartImportJobApiArgs) {
    const payload = await appDispatch(fileApi.endpoints.startImportAttachmentsJob.initiate(apiProps)).unwrap();
    return { ...payload, backgroundJobId: payload.id };
  }

  public getJobDetails(backgroundJobId: number) {
    const subscription = appDispatch(
      fileApi.endpoints.getImportAttachmentsJobDetails.initiate(backgroundJobId, { forceRefetch: true })
    );

    return subscription.unwrap().finally(() => subscription.unsubscribe());
  }

  public successCallback() {
    showSuccess(i18next.t('import-attachments-success'));

    appDispatch(fileApi.util.invalidateTags(['File']));
    appDispatch(recordApi.util.invalidateTags(['Record']));

    return Promise.resolve();
  }

  public errorCallback(responseErrors?: ValidationResponseMessage[]) {
    const errorMessage = responseErrors?.[0].message || i18next.t('import-attachments-failed');
    showError(errorMessage);
  }
}
